import { ConfigItem } from 'Core/interfaces'
import { ConfigFilterItem } from 'Core/interfaces/filters'

export enum HESSupplierLabels {
	PSVendorId = 'psVendorId',
	IsActive = 'isActive',
	Name = 'name',
	ClassCode = 'classCode',
	IsValidated = 'isValidated',
	Class = 'class',
	IsVendorActive = 'isVendorActive',
	PSVendorName = 'psVendorName',
	Id = 'id'
}

export enum HESSupplierSearchFields {
	searchById = 'searchById',
	searchByName = 'searchByName',
	searchByPSVendorId = 'searchByPSVendorId'
}

export enum HESSupplierFilterFields {
	classCodeFilter = 'classCodeFilter',
	includeInactive = 'includeInactive'
}

export declare namespace HESSupplier {
	interface Basic extends Entity {
		[HESSupplierLabels.Class]: string | null
		[HESSupplierLabels.PSVendorId]: string | null
		[HESSupplierLabels.IsActive]: boolean
	}

	interface Full extends Omit<Basic, HESSupplierLabels.Class> {
		[HESSupplierLabels.Class]: NameCode | null
		[HESSupplierLabels.PSVendorName]: string | null
	}

	namespace Form {
		interface Create {
			[HESSupplierLabels.PSVendorId]: string | null
			[HESSupplierLabels.Name]: string
			[HESSupplierLabels.ClassCode]: LabelValue
			[HESSupplierLabels.IsActive]: boolean
		}
	}

	namespace Request {
		interface Create {
			[HESSupplierLabels.PSVendorId]: string | null
			[HESSupplierLabels.Name]: string
			[HESSupplierLabels.ClassCode]: string
			[HESSupplierLabels.IsActive]: boolean
			[HESSupplierLabels.IsValidated]: boolean
		}
	}

	interface PeopleSoftData {
		[HESSupplierLabels.Name]: string
		[HESSupplierLabels.Id]: string
		[HESSupplierLabels.ClassCode]: NameCode | null
		[HESSupplierLabels.IsVendorActive]: boolean
	}

	namespace Search {
		interface Config {
			[HESSupplierSearchFields.searchById]: ConfigItem<HESSupplierSearchFields>
			[HESSupplierSearchFields.searchByName]: ConfigItem<HESSupplierSearchFields>
			[HESSupplierSearchFields.searchByPSVendorId]: ConfigItem<HESSupplierSearchFields>
		}

		interface ResultByField extends Entity {
			classCode: string | null
			psVendorId: string | null
		}

		interface Result {
			[HESSupplierSearchFields.searchById]: ResultByField[]
			[HESSupplierSearchFields.searchByName]: ResultByField[]
			[HESSupplierSearchFields.searchByPSVendorId]: ResultByField[]
		}
	}

	namespace Filter {
		interface Config {
			[HESSupplierFilterFields.classCodeFilter]: ConfigFilterItem<string, string>
			[HESSupplierFilterFields.includeInactive]: ConfigFilterItem<string, boolean>
		}
	}
}
